define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/RefImage",
	"csi/html",
	"csi/image/_base"
], function(declare,_,RefImage,html,csiImage) {

	var	_NO_IMAGE_AT_INDEX = 9999;
	
	return declare(RefImage, {
		bBaseRenderer: true,
		
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: set correct numbered key based on index given on Heading (starting with 1)
			var	node = ctx.getNode();
			if (node) {
				var	n = Number(h.m_index);
				var	keys = csiImage.getNumberedKeys(node[h.m_id]);
				ctx.keyValue = keys[n-1] || _NO_IMAGE_AT_INDEX;
			}
			
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context
			ctx.keyValue = null;
			this.inherited(arguments);
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: no editing possible
			return null;
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if no image at index, then hide
			return (ctx.keyValue == _NO_IMAGE_AT_INDEX) ? html.CSS_HIDE : this.inherited(arguments);
		}
	});
});